// Central registry of React Query keys.
//
// One place so the code that READS data (useQuery) and the code that REFRESHES it
// after a mutation (queryClient.invalidateQueries) always use the exact same key.
// If keys drift, invalidation silently stops working — this file prevents that.
//
// As each page is migrated to React Query, add its key factory here.
export const queryKeys = {
  // Shipment groups are org-scoped, so the org id is part of the key: switching
  // org can't serve another org's cached list.
  shipmentGroups: (orgId) => ['shipmentGroups', orgId],
  // Ferrero distributor overview: whether the current user may open it (decided by the backend), and
  // the rows for a look-back range ('4h', 'today', ...) — a range key, not a timestamp, so the key
  // stays stable while the window slides forward.
  ferreroOverviewAccess: (orgId) => ['ferreroOverviewAccess', orgId],
  ferreroOverview: (orgId, range) => ['ferreroOverview', orgId, range],
  // One logger, including the asset it is attached to right now (the /open page).
  device: (orgId, deviceId) => ['device', orgId, deviceId],
};

export default queryKeys;
